"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transliterate = void 0;
var sequence_1 = require("./sequence");
var remove_1 = require("./remove");
var qametsQatan_1 = require("./qametsQatan");
var titForTat_1 = require("./titForTat");
var testEach_1 = require("./testEach");
exports.Transliterate = function (text, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.isSequenced, isSequenced = _c === void 0 ? true : _c, _d = _b.qametsQatan, qametsQatan = _d === void 0 ? false : _d, _e = _b.isSimple, isSimple = _e === void 0 ? false : _e;
    var newSeq = isSequenced ? sequence_1.Sequence(text) : text;
    var rmvCantillation = remove_1.Remove(newSeq, { removeShinDot: true });
    var titTat = titForTat_1.titForTat(rmvCantillation);
    var array = titTat.split(/(\s|\S*\-)/);
    var sanitized = qametsQatan ? qametsQatan_1.qametsQ(array) : array;
    var modArray = testEach_1.testEach(sanitized, { isSimple: isSimple });
    var transliteration = modArray.reduce(function (a, c) { return a + c; }, "");
    return transliteration;
};
//# sourceMappingURL=transliterate.js.map